import React from 'react';

type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: string | number;
  className?: string;
};

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Search...',
  width = '100%',
  className = '',
}) => {
  return (
    <input
      type="text"
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className={`search-input ${className}`}
      style={{
        padding: '1rem 1rem',
        border: '1px solid #fffff',
        borderRadius: '100px',
        width,
        outline: 'none',
        transition: 'border-color 0.2s ease',
      }}
      onFocus={(e) => (e.target.style.borderColor = '#888')}
      onBlur={(e) => (e.target.style.borderColor = '#ccc')}
    />
  );
};

export default SearchInput;
